import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isDirty, isValid, reset } from 'redux-form';
import ParkCreditNotes from './ParkCreditNotes';
import { IApplicationState } from 'ducks/reducers';

const mapStateToProps = (state: IApplicationState) => ({
  dirty: isDirty('ParkCreditNotesForm')(state),
  values: getFormValues('ParkCreditNotesForm')(state),
  isValid: isValid('ParkCreditNotesForm')(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset('ParkCreditNotesForm')
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ParkCreditNotes);
